(function () {
  function syncSvg(box) {
    var svg = box.querySelector('.dotted-border');
    if (!svg) return;
    var svgRect = svg.querySelector('rect');
    if (!svgRect) return;

    var w = Math.round(box.offsetWidth);
    var h = Math.round(box.offsetHeight);
    if (!w || !h) return;

    var rx = parseFloat(window.getComputedStyle(box).borderTopLeftRadius) || 0;

    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.setAttribute('width', w);
    svg.setAttribute('height', h);
    svgRect.setAttribute('width', w);
    svgRect.setAttribute('height', h);
    svgRect.setAttribute('rx', rx);
    svgRect.setAttribute('ry', rx);
  }

  function initAll() {
    document.querySelectorAll('.dotted-box').forEach(syncSvg);
  }

  if (typeof ResizeObserver !== 'undefined') {
    var ro = new ResizeObserver(function (entries) {
      entries.forEach(function (e) { syncSvg(e.target); });
    });
    function observeAll() {
      document.querySelectorAll('.dotted-box').forEach(function (box) {
        syncSvg(box);
        ro.observe(box);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else {
      observeAll();
    }
  } else {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    window.addEventListener('resize', initAll);
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:load', initAll);
})();
